export default __webpack_public_path__ + "static/media/bannerMulher.73fc461d.jpg";